<template>
  <div :class="getScreen ? 'm-page-wrapper' : 'd-page-wrapper'">
    <a-row :gutter="16">
      <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
        <a-card :loading="loading.page">
          <div slot="title">
            PBK Manifest
            <small class="m-display-block m-text-small">{{ data.header[0] ? data.header[0].request_pbk_no : "-" }}</small>
          </div>
          <div slot="extra">
            <!-- <a-button @click="create">Select Action</a-button> -->
            <!-- <a-button
              @click="handleRectification(id)"
              icon="form"
              :loading="printLoad.recti"
              v-if="pembetulan_sts && pembetulan_sts != '0'"
              >Rectification</a-button
            >
            <a-button
                @click="handleEdit(id)"
                icon="edit"
                type="danger"
                :loading="printLoad.manifest"
                v-if="data.header.status && data.header.status != 'Release' && data.header.status != 'Done'"
                >Edit</a-button
              > -->
          </div>
          <a-row :gutter="16">
            <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
              <a-card size="small">
                <div slot="title" class="ant-card-head-title"
                  style="padding: 0px!important;font-size: 1rem;font-weight: 600">
                  Request
                </div>
                <ul class="m-list-wrapper bordered">
                  <li>
                    <span class="m-list-title">Date Create</span>
                    <span class="m-list-desc">{{ moment(data.header[0].create_date).format(getDefaultDateFormat) }}</span>
                  </li>
                  <li>
                    <span class="m-list-title">TLC Create</span>
                    <span class="m-list-desc">{{ data.header[0].tlc_create }}</span>
                  </li>
                  <li>
                    <span class="m-list-title">Request Date</span>
                    <span class="m-list-desc">{{ moment(data.header[0].request_date).format(getDefaultDateFormat)
                    }}</span>
                  </li>
                  <li>
                    <span class="m-list-title">NTPN</span>
                    <span class="m-list-desc">{{ data.header[0].ntpn }}</span>
                  </li>
                  <li>
                    <span class="m-list-title">Tax Type</span>
                    <span class="m-list-desc">{{ labelingTax(data.header[0].tax_type) }}</span>
                  </li>
                  <li>
                    <span class="m-list-title">Month-Year</span>
                    <span class="m-list-desc">{{ data.header[0].month_year }}</span>
                  </li>
                  <li>
                    <span class="m-list-title">KAP</span>
                    <span class="m-list-desc">{{ data.header[0].KAP }}</span>
                  </li>
                  <li>
                    <span class="m-list-title">KJS</span>
                    <span class="m-list-desc">{{ data.header[0].KJS }}</span>
                  </li>
                  <li>
                    <span class="m-list-title">Value</span>
                    <span class="m-list-desc">{{ formatRupiah(data.header[0].Value) }}</span>
                  </li>
                </ul>
              </a-card>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
              <a-card size="small">
                <div slot="title" class="ant-card-head-title"
                  style="padding: 0px!important;font-size: 1rem;font-weight: 600">
                  Planning
                </div>
                <ul class="m-list-wrapper bordered">
                  <li>
                    <span class="m-list-title">Tax Type</span>
                    <span class="m-list-desc">{{ labelingTax(data.plan_to_pbk[0].tax_type) }}</span>
                  </li>
                  <li>
                    <span class="m-list-title">Month-Year</span>
                    <span class="m-list-desc">{{ data.plan_to_pbk[0].month_year }}</span>
                  </li>
                  <li>
                    <span class="m-list-title">KAP</span>
                    <span class="m-list-desc">{{ data.plan_to_pbk[0].kap }}</span>
                  </li>
                  <li>
                    <span class="m-list-title">KJS</span>
                    <span class="m-list-desc">{{ data.plan_to_pbk[0].kjs }}</span>
                  </li>
                  <li>
                    <span class="m-list-title">Value</span>
                    <span class="m-list-desc">{{ formatRupiah(data.plan_to_pbk[0].value) }}</span>
                  </li>
                  <li>
                    <span class="m-list-title">Document</span>
                    <span class="m-list-desc">
                      <a-button class="margin-top" type="primary" size="small" v-if="data.plan_to_pbk[0].document"
                        @click="viewtoTab(data.plan_to_pbk[0].document_path)">
                        Document
                      </a-button>
                      <span v-else>-</span>
                    </span>
                  </li>
                  <li>
                    <span class="m-list-title">Note</span>
                    <span class="m-list-desc">{{ data.plan_to_pbk[0].note ? data.plan_to_pbk[0].note : "-" }}</span>
                  </li>
                </ul>
              </a-card>
            </a-col>
          </a-row>
        </a-card>

        <a-card class="margin-top" v-if="data.status_besar == 'On Process'">
          <div slot="title">Manifest Actions</div>

          <a-form :form="form">
            <a-form-item label="Aksi">
              <a-select @change="changeAction" v-decorator="[
                'aksi',
                {
                  rules: [{ required: true }],
                  initialValue: (data.aksi[0] ? data.aksi[0].aksi : null),
                },
              ]">
                <a-select-option v-for="item in data.aksi" :key="item.aksi">{{ item.aksi }}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item v-if="aksiSelected ==='Approval'" label="PBK Number">
              <a-input v-decorator="['no_pbk', { rules: [{ required: true }], initialValue: null, }]">
              </a-input>
            </a-form-item>
             <a-form-item v-if="aksiSelected ==='Rejected'" label="Number Rejected">
              <a-input v-decorator="['no_pbk', { rules: [{ required: true }], initialValue: null, }]">
              </a-input>
            </a-form-item>
            <a-form-item v-if="aksiSelected ==='Approval'"  label="PBK Date">
              <a-config-provider :locale="getLocalConfigProvider()">
                <a-date-picker placeholder="Select Date" :format="getDefaultDateFormat"
                  v-decorator="['pbk_date', { rules: [{ required: true }], initialValue: null }]" />
              </a-config-provider>
            </a-form-item>
            <a-form-item v-if="aksiSelected ==='Rejected'" label="Rejected Date">
              <a-config-provider :locale="getLocalConfigProvider()">
                <a-date-picker placeholder="Select Date" :format="getDefaultDateFormat"
                  v-decorator="['pbk_date', { rules: [{ required: true }], initialValue: null }]" />
              </a-config-provider>
            </a-form-item>
            <a-form-item  v-if="aksiSelected ==='Approval'" label="Upload Document PBK">
              <a-upload :fileList="fileList" v-decorator="[
                'doc_pbk',
                { rules: [{ required: true, validator: doc_validation }] },
              ]" :beforeUpload="beforeUpload">
                <a-button>
                  <a-icon type="upload" />Select File
                </a-button>
              </a-upload>
            </a-form-item>
            <a-form-item v-if="aksiSelected ==='Rejected'" label="Upload Document Rejected">
              <a-upload :fileList="fileList" v-decorator="[
                'doc_pbk',
                { rules: [{ required: true, validator: doc_validation }] },
              ]" :beforeUpload="beforeUpload">
                <a-button>
                  <a-icon type="upload" />Select File
                </a-button>
              </a-upload>
            </a-form-item>
            <a-form-item label="Note">
              <a-textarea placeholder="Write the note here ... " :rows="4" v-decorator="['note']" />
            </a-form-item>
            <a-form-item :wrapper-col="{ span: 24 }">
              <a-button @click="handleActionConfirm" :loading="loading.save" block type="primary"
                html-type="submit">Save</a-button>
            </a-form-item>
          </a-form>
        </a-card>
      </a-col>
      <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
        <a-collapse :class="getScreen ? 'margin-top' : ''" activeKey="1">
          <a-collapse-panel key="1">
            <div class="m-display-flex space-between align-middle" slot="header">
              <h4 class="margin-remove">Status</h4>
              <div>
                <Status :status="data.status_besar" />
                <!-- <a-button
                @click="historyToggle"
                type="default"
                size="small"
                class="margin-right-small"
              >
                <a-icon type="undo" />
              </a-button> -->
              </div>
            </div>
            <a-timeline class="m-timeline">
              <!-- <a-timeline-item color="green">
                <div class="m-timeline-title">
                  Pembuat - {{ data.header[0].tlc_create }}
                </div>
                <div class="m-timeline-body">
                  <h4 class="margin-remove">{{ moment(data.header[0].create_date).format('DD-MM-YYYY') }}</h4>
                  <span class="m-text-small" v-if="data.header[0].note">{{
                    data.header[0].note
                  }}</span>
                  <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                </div>
                <div class="m-timeline-footer">
                  <a-tag color="green">Created</a-tag>
                </div>
              </a-timeline-item> -->
              <a-timeline-item v-for="workflow in data.status_app" :key="workflow.step_no">
                <div class="m-timeline-title">
                  {{ workflow.actor }} - {{ workflow.tlc }}
                </div>
                <div class="m-timeline-body">
                  <h4 class="margin-remove" v-if="workflow.tanggal_aksi">
                    {{
                      moment(workflow.tanggal_aksi).format(getDefaultDateFormat)
                    }}
                  </h4>
                  <span class="m-text-small" v-if="workflow.remark">{{
                    workflow.remark
                  }}</span>
                  <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                </div>
                <div class="m-timeline-footer">
                  <Status :status="workflow.status" />
                </div>
              </a-timeline-item>
            </a-timeline>
          </a-collapse-panel>
        </a-collapse>

        <a-collapse class="margin-top" activeKey="1">
          <a-collapse-panel key="1">
            <div class="m-display-flex space-between align-middle" slot="header">
              <h4 class="margin-remove">{{ data.approval_pbk[0] ? 'Approval PBK' : 'Rejected PBK' }}</h4>
            </div>
            <ul class="m-list-wrapper bordered" v-if="data.approval_pbk[0] && data.status_besar!=='On Process'">
              <li>
                <span class="m-list-title">Date PBK</span>
                <span class="m-list-desc">{{ data.approval_pbk[0] ?
                  moment(data.approval_pbk[0].date_pbk).format(getDefaultDateFormat) : "-" }}</span>
              </li>
              <li>
                <span class="m-list-title">No PBK</span>
                <span class="m-list-desc">{{ data.approval_pbk[0] ? data.approval_pbk[0].no_pbk : "-" }}</span>
              </li>
              <li>
                <span class="m-list-title">Value</span>
                <span class="m-list-desc">{{ data.approval_pbk[0] ? formatRupiah(data.approval_pbk[0].value) : 0 }}</span>
              </li>
              <li>
                <span class="m-list-title">Note</span>
                <span class="m-list-desc">{{ data.approval_pbk[0] ? data.approval_pbk[0].note : "-" }}</span>
              </li>
              <li>
                <span class="m-list-title">Document</span>
                <span class="m-list-desc">
                  <a-button class="margin-top" type="primary" size="small"
                    :disabled="data.approval_pbk[0] && !data.approval_pbk[0].document"
                    @click="viewtoTab(data.approval_pbk[0].document_path)">Document</a-button></span>
              </li>
            </ul>
            <ul class="m-list-wrapper bordered" v-if="data.rejected_pbk[0] && data.status_besar!=='On Process'">
              <li>
                <span class="m-list-title">Date Rejected</span>
                <span class="m-list-desc">{{ data.rejected_pbk[0] ?
                  moment(data.rejected_pbk[0].date).format(getDefaultDateFormat) : "-" }}</span>
              </li>
              <li>
                <span class="m-list-title">Note</span>
                <span class="m-list-desc">{{ data.rejected_pbk[0] && data.rejected_pbk[0].note ? data.rejected_pbk[0].note
                  : "-" }}</span>
              </li>
              <li>
                <span class="m-list-title">No Rejected</span>
                <span class="m-list-desc">{{ data.rejected_pbk[0] ? data.rejected_pbk[0].no_pbk : "-" }}</span>
              </li>
              <li>
                <span class="m-list-title">Value</span>
                <span class="m-list-desc">{{ data.rejected_pbk[0] ? formatRupiah(data.rejected_pbk[0].value) : 0 }}</span>
              </li>
              <li>
                <span class="m-list-title">Document Rejected</span>
                <span class="m-list-desc">
                  <a-button class="margin-top" type="primary" size="small"
                    :disabled="data.rejected_pbk[0] && !data.rejected_pbk[0].document"
                    @click="viewtoTab(data.rejected_pbk[0].document_path)">Document Rejected</a-button></span>
              </li>
            </ul>
          </a-collapse-panel>
        </a-collapse>

        <a-collapse class="margin-top" activeKey="1">
          <a-collapse-panel key="1">
            <div class="m-display-flex space-between align-middle" slot="header">
              <h4 class="margin-remove">Realisasi PBK</h4>
            </div>

            <a-list itemLayout="horizontal" :dataSource="data.realisasi_pbk">
              <Empty v-if="data.realisasi_pbk
                ? data.realisasi_pbk.length <= 0
                : data.realisasi_pbk
                " />
              <a-list-item slot="renderItem" slot-scope="item">
                <a-list-item-meta>
                  <div slot="title" class="m-display-flex space-between align-middle">
                    <a @click="handleViews(item)">{{ item.spt_no }}</a>
                  </div>
                  <div slot="description">
                    <div class="m-width-full">
                      <span class="ant-description-ellipses">{{
                        item.spt_type_lbl
                      }} | {{ item.spt_masa_lbl }}</span>
                      {{ moment(item.create_dt).format(getDefaultDateFormat) }}
                    </div>
                  </div>
                </a-list-item-meta>
              </a-list-item>
            </a-list>
          </a-collapse-panel>
        </a-collapse>
      </a-col>
    </a-row>
  </div>
</template>

<script >
import { mapGetters } from "vuex";
import moment from "moment";
import GlobalMethod from "@/mixins/GlobalMethod";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import _ from "lodash";

export default {
  name: "manifestPBK",
  mixins: [GlobalMethod, CurrencyFormat],
  props: ["id"],
  data() {
    let doc_validation = (rule, value, callback) => {
      console.log()
      if (this.fileList && (this.fileList == null || this.fileList.length == 0)) {
        callback(new Error("Upload Document PBK is required"));
      } else {
        callback();
      }
    };
    return {
      doc_validation,
      loading: {
        page: false,
        save: false
      },
      data: {
        header: [{
          KAP: "",
          KJS: "",
          Value: "",
          create_date: "",
          month_year: "",
          ntpn: "",
          request_date: "",
          request_pbk_no: "",
          tax_type: "",
          tlc_create: "",
        }],
        plan_to_pbk: [{
          document: "",
          document_path: "",
          kap: "",
          kjs: "",
          month_year: "",
          note: "",
          tax_type: "",
          value: ""
        }],
        rejected_pbk: [],
        approval_pbk: [],
        dokumen_terkait: [],
        aksi: []
      
      },
      fileList: [],
       aksiSelected:"Approval"
    }
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
      "getType_tax",
    ]),
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  mounted() {
    this.$store.dispatch("Fetch_TYPE_TAX");
    Event.$on("confirmMessageReturn", this.handleAction);
    this.fetchData()
  },
  destroyed() {
    Event.$off("confirmMessageReturn", this.handleAction);
  },
  methods: {
    moment,
    fetchData() {
      this.asyncAxiosGet("pbk",
        this.getAuth,
        {
          id_manifest: this.id
        }
      ).then((res) => {
        this.data = res
      })
    },
    viewtoTab(url) {
      window.open(this.$serviceUrl + url);
    },
    handleActionConfirm() {
      this.form.validateFields((err) => {
        if (err) {
          this.displayMessage("choose-action");
          return;
        }
        this.confirmMessage("confirm-save");
      })
    },
    handleAction() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("choose-action");
          return;
        }

        let post = new FormData();
        post.append("id_manifest", this.id);
        post.append("status", values.aksi);
        post.append("pbk_date", moment(values.pbk_date).format(this.getStandartFormatDate));
        post.append("note", values.note ? values.note : "");
        post.append("no_pbk", values.no_pbk);
        post.append("doc_pbk", this.fileList[0]);

        this.loading.save = true;

        this.asyncAxiosPost("pbk/approval", "formdata", this.getAuth, post)
          .then((response) => {
            if (response.status && response.status == true) {
              this.displayMessageValue("success-other", response.message);
              this.$router.go();
            } else {
              let responses = Object.assign({}, response);
              this.displayMessageValue("error-other", responses);
            }
            this.loading.save = false;
          })
          .catch(() => {
            this.loading.save = false;
          })
      });
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        this.fileList = [];
        this.fileList.push(file);
        return false;
      }
    },
    labelingTax(val) {
      let result = _.filter(this.getType_tax, (item) => item.value == val);
      return (result.length > 0 ? result[0].text : "");
    },
    changeAction(item) {
      this.aksiSelected = item;
    },
    handleViews(item) {
      this.$router.push({
        name: "SPTManifest",
        params: { id: item.spt_id, tipe: item.spt_type },
      });
    }
  }
}
</script>